<template>
  <!-- todo : rebuild library song picker -->
  <document-view-with-toolbar
    class="no print"
    @close="close"
    @toggle-add-on-item-from-included="toggleFormFromIncluded"
    @save-button-clicked="saveForms"
    :icons="icons"
    :saveProcessing="saveProcessing"
    :addOnItems="businessForms"
    :includedItems="mergedForms"
    :documents="mergedForms"
    addOnItemTitle="name"
  >
    <template v-slot:document="document">
      <div class="form-wrapper" :id="document.document.id">
        <img :src="logo" alt="Business Logo" />
        <h2 class="form-title">{{ document.document.name }}</h2>
        <p v-if="document.document.description">
          {{ document.document.description }}
        </p>
        <div
          class="library-enable-disclaimer no-print"
          v-if="hasLibraryFields(document.document)"
        ></div>
        <playlist-display
          class="playlist-display"
          v-if="document.document.streamingEnabled"
          @playlist-link-input="playlistLinkInput($event, document.document)"
          :url="document.document.streamingURI"
        />
        <FormItem
          v-for="(field, index) in document.document.fields"
          :key="index"
          :item="field"
          :class="emptyField(field) ? 'empty' : ''"
          @duplicate-field="duplicateField(document.document, field, index)"
          @activate-library="activateLibrary(field)"
        />
        <h2 class="event-title">{{ event.title }}</h2>
      </div>
    </template>
  </document-view-with-toolbar>
</template>
<script>
import DocumentViewWithToolbar from "../Documents/DocumentViewWithToolbar.vue";
import FormItem from "../UI/FormItem.vue";
import PlaylistDisplay from "../Spotify/PlaylistDisplay.vue";
import _ from "lodash";
export default {
  data() {
    return {
      deleteFormOpen: false,
      formDeleteIndex: undefined,
      libraryActiveField: undefined,
      saveProcessing: false,
      mergedForms: [],
    };
  },
  computed: {
    businessForms() {
      return this.$store.getters.forms;
    },
    // mergedForms() {
    //   return
    // },
    role() {
      return this.$store.getters.userRole;
    },
    icons() {
      let array = ["print"];
      if (this.role === "admin") {
        array.push("save", "plus-sign");
      }
      if (this.role === "organizer" || this.role === "client") {
        array.push("save");
      }
      return array;
    },
    logo() {
      return this.$store.getters.businessLogo;
    },
  },
  methods: {
    emptyField(field) {
      let fields = field.fields;
      return fields.every((x) => {
        return x.value === undefined;
      });
    },
    hasLibraryFields(form) {
      if (
        form.fields.find((x) => {
          return x.libraryEnabled === true;
        })
      ) {
        return true;
      }
    },
    close() {
      this.saveForms();
      this.$emit("close");
    },
    playlistLinkInput($event, document) {
      document.streamingURI = $event;
      this.saveForms();
    },
    fieldInput(object, property, value) {
      if (object) {
        object[property] = value;
      } else {
        this[property] = value;
      }
    },
    async saveForms() {
      this.saveProcessing = true;
      let editPayload = {
        eventKey: { userId: this.event.userId, tenantId: this.event.tenantId },
        api_version: this.event.api_version,
        variable: "forms",
        value: this.mergedForms,
      };
      await this.$store.dispatch("editEvent", editPayload);
      this.saveProcessing = false;
    },
    duplicateField(form, fieldItem, formItemIndex) {
      // todo : clear values from field & potentially remove lodash
      form.fields.splice(formItemIndex, 0, _.cloneDeep(fieldItem));
      form.fields[formItemIndex].duplicable = false;
    },
    //  todo : add delete field button
    async toggleFormFromIncluded(form) {
      let index = this.mergedForms.findIndex((x) => {
        return x.id
          ? x.id === form.id
          : x.name
          ? x.name === form.name
          : x === form;
      });
      if (index > -1) {
        this.mergedForms.splice(index, 1);
      } else {
        this.mergedForms.push(form);
      }
      let editPayload = {
        eventKey: { userId: this.event.userId, tenantId: this.event.tenantId },
        api_version: this.event.api_version,
        variable: "forms",
        value: this.mergedForms,
      };
      await this.$store.dispatch("editEvent", editPayload);
    },
    activateLibrary(field) {
      this.libraryActiveField = field;
    },
    addTrackToField(track) {
      this.libraryActiveField.libraryMatch = track;
      this.libraryActiveField.fields[0].value = track["Name"];
      this.libraryActiveField.fields[1].value = track["Artist"];
      this.changeLibraryActiveField(undefined);
    },
    addFormToEvent(form) {
      this.$emit("addFormToEvent", form);
    },
    initiateDeleteForm(index) {
      this.formDeleteIndex = index;
      this.deleteFormOpen = true;
    },
    closeDeleteForm() {
      this.deleteFormOpen = false;
    },
    deleteForm() {
      this.$emit("deleteForm", this.formDeleteIndex);
      this.closeDeleteForm();
    },
    firstDuplicatedForm(form, field) {
      return form.fields.findIndex((x) => x.name == field.name);
    },
    closeSongPicker() {
      this.libraryActiveField = undefined;
    },
  },
  created() {
    if (this.event.userId === this.$route.params.eventId) {
      this.mergedForms = this.event.forms.map((form) => {
        if (this.businessForms) {
          let matchedForm = this.businessForms.find((businessForm) => {
            return form.id
              ? businessForm.id === form.id
              : form.name === businessForm.name;
          });
          if (matchedForm) {
            return { ...matchedForm, ...form };
          } else {
            return form;
          }
        } else {
          return form;
        }
      });
    }
  },
  components: {
    DocumentViewWithToolbar,
    FormItem,
    PlaylistDisplay,
  },
  emits: ["close"],
  props: ["forms", "event"],
};
</script>
<style scoped>
@media screen {
  .no-screen {
    display: none;
  }

  img,
  .event-title {
    display: none;
  }

  h2 {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }
  h4 {
    font-size: 0.8rem;
  }

  p {
    font-size: 0.8rem;
  }

  #forms-wrapper {
    z-index: 100;
    backdrop-filter: blur(3px);
  }

  .library-enable-disclaimer {
    position: absolute;
    display: flex;
    align-items: center;
    right: -20px;
    top: -60px;
  }

  .form-wrapper {
    position: relative;
  }
}

@media print {
  @page {
    margin: auto auto 0 auto;
  }

  #forms-wrapper {
    backdrop-filter: unset;
    z-index: unset;
    display: unset;
    overflow: visible;
    position: unset;
  }

  .form-title {
    text-align: center;
    border-bottom: 1px solid #212121;
    width: 100%;
    text-align: center;
    top: 0;
  }
  img {
    position: fixed;
    right: 0;
    top: 0;
    height: 20px;
  }

  .form-wrapper {
    width: 100%;

    max-height: 90%;
    page-break-after: always;
  }

  h4 {
    margin-bottom: 0;
  }

  .event-title {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 0px;
  }
  .empty {
    display: none;
  }
  .no-print {
    display: none;
  }
}
</style>
